import makeHTTPRequest from '../makeHTTPRequest';

export const fetchFeatureFlags = () => makeHTTPRequest({ path: '/features' });
